export default "__VITE_ASSET__BjPW1wGJ__"